import { processingSessionIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const abandonProcessingSession = {
  name: "abandonProcessingSession" as const,
  input: z.object({ sessionId: processingSessionIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
